import React from "react";
import { FormControl, FormLabel, Select } from "@chakra-ui/react";

/**
 * Wraps Chakra `Select` with a normalized options API.
 *
 * `options` accepts either:
 *   - an array of strings: ["Long", "Short"]
 *   - an array of `{ label, value }` objects
 *
 * If `label` is provided, the control is wrapped in a `FormControl` with a
 * `FormLabel`. Otherwise the bare `Select` is returned.
 */
const FilterSelect = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = "All",
  size = "sm",
  isDisabled = false,
  formControlProps,
  labelProps = { fontSize: "xs", mb: 1 },
  ...selectProps
}) => {
  const select = (
    <Select
      size={size}
      value={value ?? ""}
      placeholder={placeholder}
      onChange={onChange}
      isDisabled={isDisabled}
      {...selectProps}
    >
      {options.map((opt) => {
        const isObject = opt !== null && typeof opt === "object";
        const optValue = isObject ? opt.value : opt;
        const optLabel = isObject ? opt.label : opt;
        return (
          <option key={String(optValue)} value={optValue}>
            {optLabel}
          </option>
        );
      })}
    </Select>
  );

  if (!label) return select;

  return (
    <FormControl {...formControlProps}>
      <FormLabel {...labelProps}>{label}</FormLabel>
      {select}
    </FormControl>
  );
};

export default FilterSelect;
